import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authService } from '../../Services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const ForgetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { from } = location.state || { from: { pathname: "/user/home" } };

  const auth = useSelector((state) => state.auth);
  useEffect(() => {  
    if (auth && auth.token) {
      return navigate(from);
    }
  }, []);

  const [input, setInput] = useState({
    username: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [msg, setMsg] = useState("");

  const submitForm = () => {
    setMsg("");
    if(!input.username) {
      setSubmitted(false);
      setMsg("Email is required");
      return;
    }
    authService.sendResetPasswordLink(input).then(auth => {
      setSubmitted(false);
      if(auth.status == 0) {
        setMsg(auth.msg);
        return;
      }
      navigate("/login");
    });
  }

  const handleChange = (e) => {
    setMsg("");
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitForm();
  }

  return (
    <>
      {/* <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" >
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="page-banner-cont">
                        <h4>Login</h4>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Login</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      </section> */}

      <section className="pb-50">
        <div className="container">
          <div className="row">
            <div className='col-md-12'>
              <div className="contact-from offset-md-3 col-md-6">
                <fieldset className='border p-4 shadow-lg'>
                  <legend className='w-auto'>
                    Forgot Password?
                  </legend>
                  <div className="main-form">
                    <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="singel-form form-group">

                            <input name="username" type="text" placeholder="Your Email" value={input.username} onChange={handleChange} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          {msg && <p className="msg login text-danger mt-2">{msg}</p>}
                          <div className="singel-form">
                            <button type="submit" className="main-btn disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Send Reset Password Link</span>}
                            </button>
                          </div>
                          {/* <p className='mt-2'>
                            <Link to={"/register"} className="btn btn-primary"><strong>New applicants register here</strong></Link>
                          </p> */}
                          <p className='mt-2'>
                            <Link to={"/login"} className="">Login</Link>
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </fieldset>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;